export enum Roles {
    SUPERADMIN = 0,
    MANAGER = 1,
    LOGBOOKER = 2,
    ASSISTANT = 3,
    SALES = 4,
    CHECKER = 5,
}